export default __webpack_public_path__ + "static/media/nikeWinAsTeam.9030318a.jpeg";